import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/react';

import SlickComponent from './slickComponentDesktop';
import './gallerySliderStyle.less';

class GallerySlider extends Component {
  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      contexts: {
        'Error Info': errorInfo || {}
      }
    });
  }

  renderDesktopSlider() {
    return <SlickComponent />;
  }

  render() {
    return <div id="gallerySlider">{this.renderDesktopSlider()}</div>;
  }
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(GallerySlider);
